import React from "react";
import TermsModal from "./TermsModal";
import ModalButton from "../global/ModalButton";
import { useGetDictionary } from "../../hooks/useGetDictionary";
import { DictionaryType } from "../../types";

const TermsAndConditions = ({ customStyle }: any) => {
  const { Auth }: DictionaryType = useGetDictionary();
  const terms_and_conditions = [
    {
      title: Auth?.privacy_policy,
      name: "privacy",
    },
    {
      title: Auth?.terms_and_conditions,
      name: "terms",
      href: "https://drive.google.com/file/d/1asJ7uMdE64eJX9CAHUPVMd_lmk7Oc3WS/view?usp=drivesdk",
    },
    {
      title: Auth?.help,
      name: "help",
      href: "https://help.mocion.io/hc/en-us",
    },
  ];
  return (
    <div className="flex justify-center gap-12">
      {terms_and_conditions.map((element) => {
        return (
          <>
            {element.name !== "help" ? (
              <ModalButton
                buttonContent={
                  <p
                    className={`${"text-primary dark:text-white"} text-lg font-normal leading-[32.68px] no-underline ${customStyle}`}
                  >
                    {element.title}
                  </p>
                }
                modalContent={
                  <TermsModal name={element.name} href={element.href} />
                }
                modalMaxWidth="h-[90vh] max-w-3xl"
              />
            ) : (
              <p
                className={`${"text-primaryRed "} text-lg font-normal leading-[32.68px] no-underline cursor-pointer ${customStyle}`}
              >
                <a
                  href="https://help.mocion.io/hc/en-us"
                  target="_blank"
                  rel="noreferrer"
                >
                  {Auth?.help}
                </a>
              </p>
            )}
          </>
        );
      })}
    </div>
  );
};

export default TermsAndConditions;
